"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersList = function (_a) {
    var providers = _a.providers, onItemClick = _a.onItemClick, selectedProviderSlug = _a.selectedProviderSlug;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, providers.map(function (provider) {
        return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.providerItem, " ").concat(selectedProviderSlug === provider.slug ? styles_module_scss_1.default.selected : ''), onClick: function () { return onItemClick && onItemClick(provider); }, key: provider.slug },
            react_1.default.createElement("object", { className: styles_module_scss_1.default.object, data: "/img/providers/".concat(provider.slug, ".svg"), type: "image/png" },
                react_1.default.createElement("img", { src: "/img/providers/default.svg", alt: provider.title })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.providerItemRect }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, provider.title)));
    })));
};
exports.default = ProvidersList;
